export default {"src":"/_next/static/media/Avatar group.ace4b3b8.svg","height":60,"width":124,"blurWidth":0,"blurHeight":0};